import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './hp-nav-flyout-mobile.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class HpNavFlyoutMobile extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      // Global Navigation Menu
      globalLinks: { type: Array },
      isOpen: { type: Boolean },
      isDropdownOpen: { type: Boolean },
      // Links from main nav
      links: { type: Array },
      linkClass: { type: String },
      search: { type: Object },
      // Secondary Navigation Menu
      secondaryLinks: { type: Array },
      // Teired links from main nav
      tier1Links: { type: Array },
      tier2Links: { type: Array },
      tier3Links: { type: Array },
    };
  }

  constructor() {
    super();
    this.activeItemClass = '';
    this.globalLinks = [];
    this.isOpen = false;
    this.isDropdownOpen = false;
    this.linkClass = '';
    this.secondaryLinks = [];
    this.mainLinks = [];
    this.tier1Links = [];
    this.tier2Links = [];
    this.tier3Links = [];
    this.lastTier = [];
  }

  firstUpdated() {
    if (this.links && this.links.length) {
      this.mainLinks = [...this.links[0].sub]
      this.lastTier = this.mainLinks.splice(-1)[0]
      this.tier1Links = this.links.slice(1, this.links.length)
      this.tier2Links = this.mainLinks;

      if(this.tier2Links.length) {
        this.tier2Links.map((link, index) => {
          if(link.sub?.length) {
            this.tier3Links.push(link.sub);
          }
        });
      }
    }
  }

  renderTierList(list) {
    let listResult = [];

    list.map(subLink => {
      listResult.push(subLink);
    });

    return listResult;
  }

  menuItemOnClick(event) {
    const langToggleClass = 'nav-flyout-mobile__secondary-menu-link--language';
    const dropdownToggleClass = 'nav-flyout-mobile__link--dropdown';
    if (
      event.target.classList.contains(langToggleClass) ||
      event.target.parentNode.classList.contains(langToggleClass)
    ) {
      const langModal = this.shadowRoot.getElementById('lang-modal');
      langModal.toggleModal();
      event.preventDefault();
    } else if (
      event.target.classList.contains(dropdownToggleClass) ||
      event.target.parentNode.classList.contains(dropdownToggleClass)
    ) {
      let li = event.target.parentNode;

      if (li.tagName !== 'LI') {
        li = li.parentNode;
      }

      li.classList.toggle('active')
      event.preventDefault();
    }
  }

  _menuModal(link, menuName) {
    if (link.dropdownlist) {
      const isLanguageSubMenu = this.hasLanguageMenu(link);
      return html`
        <hf-icon
          class="${classMap({
            [`nav-flyout-mobile__link-icon`]: true,
            [`nav-flyout-mobile__link-icon--language`]: isLanguageSubMenu,
            active: link.active,
          })}"
          name="${isLanguageSubMenu ? 'chevron-right' : 'chevron-down'}"
        ></hf-icon>
      `;
    }

    return nothing;
  }

  _menuItem(link, menuName) {
    return html`
      <li class="nav-flyout-mobile__${menuName}-item">
        <a
          href=${link.url}
          target="_self"
          @click="${this.menuItemOnClick}"
          class="${classMap({
            [`nav-flyout-mobile__${menuName}-link`]: true,
            [`nav-flyout-mobile__link--dropdown`]: link.dropdownlist,
            [`nav-flyout-mobile__${menuName}-link--language`]: this.hasLanguageMenu(link),
            active: link.active,
          })}"
        >
          ${link.iconname
            ? html`
                <hf-icon
                  name="${link.iconname}"
                  class="nav-flyout-mobile__${menuName}--icon"
                  height="23"
                  width="23"
                ></hf-icon>
              `
            : nothing}
          <span
            class="${classMap({
              [`nav-flyout-mobile__${menuName}-link-text`]: true,
              [`nav-flyout-mobile__${menuName}-link-text--language`]:
                link.dropdownlist,
            })}"
            >${link.text}</span
          >
          ${this._menuModal(link, menuName)}
        </a>
        ${this.hasLanguageMenu(link) ? this.renderLanguageModal(link, menuName) : nothing}
        ${this.hasSubMenu(link) ? this.renderSubMenu(link, menuName) : nothing}
      </li>
    `;
  }

  hasSubMenu(link) {
    return link.dropdownlist && !this.hasLanguageMenu(link)
  }

  renderSubMenu(link, menuName) {
    return html`
      <ul class="nav-flyout-mobile__menu-item-dropdown-list">
        ${Object.keys(link.dropdownlist).map(
          item => {
            return html`
              <li
                class="${classMap({
                  [`nav-flyout-mobile__menu-item-dropdown-list-item`]: true,
                  [`nav-flyout-mobile__menu-item-dropdown-list-item--active`]: link.dropdownlist[item].active,
                  [`nav-flyout-mobile__menu-item-dropdown-list-item--${menuName}`]: true,
                })}"
              >
                <a href="${link.dropdownlist[item].url}">
                  ${link.dropdownlist[item].text}
                </a>
              </li>`
          }
        )}
      </ul>`
  }

  renderLanguageModal(link, menuName) {
    return html`
      <hf-takeover-modal
        id="lang-modal"
        .isWhite="${true}"
        .forceTop="${true}"
        .noTrigger="${true}"
        .goBackArrow="${true}"
        .expandContentsOnLarge="${false}"
      >
        <div slot="modal_content">
          <ul class="nav-flyout-mobile__${menuName}-dropdown-list">
            ${Object.keys(link.dropdownlist).map(
              language => {
                return html`
                  <li
                    class="${classMap({
                      [`nav-flyout-mobile__${menuName}-dropdown-list-item`]: true,
                      [`nav-flyout-mobile__${menuName}-dropdown-list-item--active`]:
                      link.dropdownlist[language].active,
                    })}"
                  >
                    <a href="${link.dropdownlist[language].url}">
                      ${link.dropdownlist[language].text}
                    </a>
                  </li>`
              }
            )}
          </ul>
        </div>
      </hf-takeover-modal>
    `
  }

  hasLanguageMenu(link) {
    return link.dropdownlist
      && link.dropdownlist.hasOwnProperty('en')
      && link.dropdownlist['en'].isLanguage
  }

  renderList(list) {
    if (list) {
      let templateResult = [];
      const links = list.filter(link => !link.sub.length);

      links.map(subLink => {
        templateResult.push(
          html`
            <li class="nav-flyout-mobile__tier3-links-item">
              <a
                href=${subLink.url}
                target="_self"
                class="nav-flyout-mobile__sub-link"
              >
                ${subLink.iconName
                  ? html`
                    <hf-icon
                      name="${subLink.iconName}"
                      class="nav-flyout-mobile__sub-link--icon"
                      height="24"
                      width="24"
                    ></hf-icon>
                  `
                  : nothing}
                <span class="nav-flyout-mobile__sub-link-text">${subLink.text}</span>
              </a>
            </li>`
        );
      });

      return templateResult;
    }
  }

  render() {
    return html`<div
      class="${classMap({
        'nav-flyout-mobile__wrapper': true,
        [`nav-flyout-mobile--open`]: this.isOpen,
        [`nav-flyout-mobile--closed`]: !this.isOpen,
      })}"
    >
      <div class="nav-flyout-mobile__header">
        <hf-link href="/" target="_self" icon>
          <div class="nav-flyout-mobile__logo-wrapper">
            <hf-icon class="nav-flyout-mobile__logo" name="hf-logo"></hf-icon>
          </div>
        </hf-link>
        <ul class="nav-flyout-mobile__global-menu-wrapper">
          ${this.globalLinks.map(link => {
            return this._menuItem(link, 'global-menu');
          })}
        </ul>
        <hf-search
          class="nav-flyout-mobile__search"
          placeholder="${this.search.text}"
          searchUrl="${this.search.url}"
        ></hf-search>
      </div>
      <div class="nav-flyout-mobile__prime-links-wrapper">
        <ul class="nav-flyout-mobile__tier2-links-wrapper">
          ${this.tier2Links.map(link => {
            return this._menuItem(link, 'tier2-links');
          })}
        </ul>
        <ul class="nav-flyout-mobile__tier1-links-wrapper">
          ${this.tier1Links.map(link => {
            return this._menuItem(link, 'tier1-links');
          })}
        </ul>
      </div>
      <div class="nav-flyout-mobile__secondary-links-wrapper">
        <ul class="nav-flyout-mobile__secondary-menu-wrapper">
          ${this.secondaryLinks.map(link => {
            return this._menuItem(link, 'secondary-menu');
          })}
        </ul>

        ${this.lastTier && this.lastTier.sub && Array.isArray(this.lastTier.sub) ? html`
          <ul class="nav-flyout__sub-links-wrapper--2">
            ${this.renderList(this.lastTier.sub)}
          </ul>
        ` : nothing}
      </div>
    </div>`;
  }
}

customElements.define('hf-hp-nav-flyout-mobile', HpNavFlyoutMobile);
